import script from "./TripStops.vue?vue&type=script&setup=true&lang=js"
export * from "./TripStops.vue?vue&type=script&setup=true&lang=js"

import "./TripStops.vue?vue&type=style&index=0&id=630a1aab&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-630a1aab"]])

export default __exports__